import { Component, Input, AfterViewInit, OnDestroy } from '@angular/core';
import { AbstractControl } from '@angular/forms';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

import { AppErrorMessagesService } from '../services/app-error-messages.service';
import { NgClass } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';

@Component({
    selector: 'app-error-messages',
    templateUrl: './app-error-messages.component.html',
    styleUrls: ['./app-error-messages.component.scss'],
    imports: [NgClass, TranslateModule]
})
export class AppErrorMessagesComponent implements AfterViewInit, OnDestroy {
  @Input() control: AbstractControl;

  @Input() showUntouchedErrors = false;
  @Input() asFreeText = false;

  public errors: { key: string; translate: boolean; params: { [param: string]: any } }[] = [];

  public get showErrors(): boolean {
    const showErrors = this.control.invalid && (this.control.dirty || this.control.touched || (this.showUntouchedErrors && this.control.untouched));
    if(this.lastShowErorrs != showErrors) {
      // workaround for invalid and newly touched, since this is not cought by this.control.statusChanges
      this.generateErrorMessages();
    }
    this.lastShowErorrs = showErrors;
    return showErrors;
  }

  private readonly unsubscribe: Subject<void> = new Subject();
  private lastShowErorrs = false;

  constructor(private readonly errorMessagesService: AppErrorMessagesService) {}

  ngAfterViewInit() {
    this.control.statusChanges
      .pipe(takeUntil(this.unsubscribe))
      .subscribe(() => this.generateErrorMessages());
  }

  public ngOnDestroy(): void {
    this.unsubscribe.next();
    this.unsubscribe.complete();
  }

  private generateErrorMessages() {
    if (this.control.invalid) {
      this.errors = this.errorMessagesService.createMessages(this.control);
    } else {
      this.errors = [];
    }
  }
}
